import React from "react"
import Contact from "../public/Contact"
import MenuHospital from "./navHospital/MenuHospital"

function ContactHospital() {
    return(
        <div>
            <MenuHospital menuActive='contact' />
            <Contact disabledMenu/>
        </div>
    )
}
export default ContactHospital